module.exports = __webpack_public_path__ + "img/master_isotipo_VP.67c145cb.svg";